import { createSelector } from 'reselect';
import { cond, identity } from 'ramda';

import { getTotalCompareInterval } from './intervals';
import { getCrimeTypeText } from './crimes';
import {
  getExportCompare,
  getExportPrecision,
  getExportTimespanInterval,
} from './exportDialog';
import { ExportFileFormat } from '../constants';
import { capitalize } from '../utils/helpers';
import { getFileFormat } from './exportDialog';
import { TimeRange } from '../components/CrimeCount';

const getChildrenText = cond([
  [elem => typeof elem === 'string', identity],
  [
    ({ props }) => typeof props.children === 'string',
    ({ props }) => props.children,
  ],
  [
    ({ props }) => props.children,
    ({ props }) => props.children.map(getChildrenText).join(''),
  ],
]);

export const getExportTimeRangeText = createSelector(
  getExportPrecision,
  getExportCompare,
  getExportTimespanInterval,
  getTotalCompareInterval,
  (precision, compare, timespanInterval, compareInterval) =>
    getChildrenText(
      TimeRange({
        precision,
        compare,
        timespanInterval,
        compareInterval,
      }),
    ),
);

export const getExportDatasetSaveAs = createSelector(
  getCrimeTypeText,
  getExportTimeRangeText,
  getFileFormat,
  (crimeTypeText, timeRangeText, fileFormat) =>
    capitalize(crimeTypeText) +
    ' for ' +
    timeRangeText +
    (fileFormat === ExportFileFormat.CSV ? '.csv' : '.xlsx'),
);



// WEBPACK FOOTER //
// ./src/selectors/exportSaveAs.js